import React from "react";
import { Box, Grid, InputLabel } from "@mui/material";
import AvatarPanel from "./AvatarPanel.tsx";
import MemoryRow from "./MemoryRow.tsx";
import { Trans } from "@lingui/react/macro";

interface ShowMemoriesProps {
  children?: React.ReactNode;
  content: Array<any>;
  role: string;
  onMemoryUpdated?: () => void;
  showAvatar?: boolean;
  showListLabel?: boolean;
}

const ShowMemories: React.FC<ShowMemoriesProps> = (props) => {
  const shouldShowAvatar = props.showAvatar ?? true;
  const shouldShowListLabel = props.showListLabel ?? true;

  return (
    <Box marginBottom={"10%"}>
      <Grid
        container
        direction="row"
        spacing={2}
        alignContent="flex-start"
        alignItems="flex-start"
      >
        {shouldShowAvatar && (
          <Grid size={{ xs: 1, lg: 1 }}>
            <AvatarPanel />
          </Grid>
        )}
        <Grid size={shouldShowAvatar ? { xs: 11, lg: 11 } : { xs: 12, lg: 12 }}>
          {shouldShowListLabel && (
            <InputLabel sx={{ marginBottom: "3%", marginTop: "1.5%" }}>
              <Trans
                context={"Input label listing all the memories of the user"}
              >
                Here is a list of your memories
              </Trans>
            </InputLabel>
          )}
          {props.content.map((item) => (
            <Box key={item.id} sx={{ mb: 1.5 }}>
              <MemoryRow
                memory={item.memory}
                id={item.id}
                onMemoryUpdated={props.onMemoryUpdated}
              />
            </Box>
          ))}
        </Grid>
      </Grid>
    </Box>
  );
};

export default ShowMemories;
